'use client';

import Icon from '@/components/ui/AppIcon';

const UKOfficeMap = () => {
  const officeDetails = {
    name: 'DIAL FOR FLIGHT - Private Limited Company',
    companyNumber: 'Company Number: 17005493',
    address: '36 Santiago Street, Manchester, United Kingdom, M14 4BL',
    phone: '07445270141',
    email: 'support@dialforflight.com',
    hours: [
      { day: 'Monday - Friday', time: '9:00 AM - 6:00 PM GMT' },
      { day: 'Saturday', time: '10:00 AM - 4:00 PM GMT' },
      { day: 'Sunday', time: 'Closed (Chat support available)' },
    ],
  };

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground mb-4">
            Visit Our UK Office
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Located in Manchester, our office is open for in-person consultations
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Map */}
          <div className="rounded-2xl overflow-hidden shadow-3d border-2 border-border h-[400px] lg:h-[500px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2374.8!2d-2.2426!3d53.4584!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487bb1e5c5c5c5c5%3A0x5c5c5c5c5c5c5c5c!2s36%20Santiago%20Street%2C%20Manchester%20M14%204BL%2C%20UK!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="DIAL FOR FLIGHT UK Office Location"
            />
          </div>

          {/* Office Details */}
          <div className="space-y-6">
            <div className="bg-gradient-to-br from-primary via-secondary to-ocean rounded-2xl shadow-3d p-8 text-white">
              <div className="flex items-start gap-4 mb-6">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-white/20 backdrop-blur-sm rounded-lg flex-shrink-0">
                  <Icon name="MapPinIcon" size={24} className="text-accent" />
                </div>
                <div>
                  <h3 className="font-heading text-2xl font-black mb-2">{officeDetails?.name}</h3>
                  <p className="text-white/90 text-sm mb-2">{officeDetails?.companyNumber}</p>
                  <p className="text-white/90">{officeDetails?.address}</p>
                </div>
              </div>

              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <Icon name="PhoneIcon" size={20} className="text-accent flex-shrink-0" />
                  <span className="text-white/90">{officeDetails?.phone}</span>
                </div>
                <div className="flex items-center gap-3">
                  <Icon name="EnvelopeIcon" size={20} className="text-accent flex-shrink-0" />
                  <span className="text-white/90">{officeDetails?.email}</span>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-brand-lg p-8 border-2 border-border">
              <h4 className="font-heading text-xl font-black text-foreground mb-4 flex items-center gap-2">
                <Icon name="ClockIcon" size={24} className="text-primary" />
                Office Hours
              </h4>
              <div className="space-y-3">
                {officeDetails?.hours?.map((schedule, index) => (
                  <div key={index} className="flex justify-between items-center py-2 border-b border-border last:border-0">
                    <span className="font-bold text-foreground">{schedule?.day}</span>
                    <span className="text-muted-foreground">{schedule?.time}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-gradient-to-r from-accent/10 to-sky-blue/10 rounded-xl p-6 border-2 border-accent/30">
              <div className="flex items-start gap-3">
                <Icon name="InformationCircleIcon" size={24} className="text-primary flex-shrink-0 mt-1" />
                <div>
                  <h5 className="font-bold text-foreground mb-2">Walk-ins Welcome</h5>
                  <p className="text-sm text-muted-foreground">
                    No appointment necessary during office hours. For guaranteed availability, we recommend booking a consultation via phone or email.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UKOfficeMap;